var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgXCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9.496 8.588a.7.7 0 1 0-.99.99l2.505 2.505-2.505 2.505a.7.7 0 0 0 .99.99L12 13.073l2.505 2.505a.7.7 0 0 0 .99-.99l-2.505-2.505 2.505-2.505a.7.7 0 0 0-.99-.99L12 11.093z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 2.383a9.7 9.7 0 1 0 0 19.4 9.7 9.7 0 0 0 0-19.4M6.133 6.214A8.3 8.3 0 1 1 17.87 17.952 8.3 8.3 0 0 1 6.132 6.214",
  clipRule: "evenodd"
})));
export default SvgXCircle;